

































































































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {EventBus} from '@/utils/EventBus';
import {Notify} from '@/utils/Notify';

import {UpgradeState} from '@/model/system/update/UpgradeState';

import {ISystemOsService} from '@/services/system/IOs.service';

import {AuthStore} from '@/store/Auth.store';
import {ApiStore} from '@/store/Api.store';
import {AppStore} from '@/store/App.store';
import SystemUpgradeStore from '@/store/system/SystemUpgrade.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import About from '@/components/About.vue';

@Component({
  components: {About},
})
export default class Toolbar extends Mixins<BaseComponent>(BaseComponent) {
  private UpgradeState = UpgradeState;

  @Inject(Symbol.for('ISystemOsService'))
  private systemOsService!: ISystemOsService;

  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  private systemUpgradeStore: SystemUpgradeStore = getModule(SystemUpgradeStore, this.$store);

  @Inject(Symbol.for('AuthStore'))
  private authStore!: AuthStore;

  private appStore: AppStore = getModule(AppStore, this.$store);

  private EventBus = EventBus;

  private showRebootConfirmation: boolean = false;
  private rebooting = false;

  private showShutdownConfirmation: boolean = false;
  private shuttingDown = false;
  private shutdownConfirmation: string = '';

  get apiUrl(): string {
    return this.apiStore.Remote + '/api';
  }

  private logout() {

    this.authStore.logout();

    Notify.Info(this.logger, 'You have been successfully logged out');

    this.$router.push({
      name: 'login',
    });
  }

  private async reboot() {
    try {
      this.rebooting = true;
      await this.systemOsService.reboot('Manual reboot requested from the Manager GUI');
    } catch (error) {
      Notify.Error(this.logger, `Could not reboot the system`, error);
    } finally {
      this.rebooting = false;
      this.showRebootConfirmation = false;
    }
  }

  private async shutdown() {
    try {
      this.shuttingDown = true;
      await this.systemOsService.shutdown('Manual shutdown requested from the Manager GUI', 1);
      this.logout();
    } catch (error) {
      Notify.Error(this.logger, `Could not shutdown the system`, error);
    } finally {
      this.shuttingDown = false;
      this.showShutdownConfirmation = false;
    }
  }

  private openRebootDialog() {
    this.showRebootConfirmation = true;

    try {
      this.systemUpgradeStore.fetchState();
    } catch (error) {
      this.logger.error(`Could not check upgrade status`, error);
    }
  }
}
